<template>
  <el-container>
    <el-main>
      <span>my score</span>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'ExamScoreIndex',
  data() {
    return {
    }
  },
  created() {
    document.title = '我的成绩'
    this.getData()
  },
  methods: {
    getData() {
      this.$message.info('获取成绩数据')
    }
  }
}
</script>

<style>
</style>
